import { changetheme } from '@/app/store/layout/layout-action'
import { DOCUMENT } from '@angular/common'
import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  EventEmitter,
  Inject,
  Output,
  inject,
} from '@angular/core'
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap'
import { Store } from '@ngrx/store'
import { getLayoutColor } from '../../store/layout/layout-selector'
import { Router } from '@angular/router'
import { SessionService } from '@/app/core/services/session.service'

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [NgbDropdownModule],
  templateUrl: './topbar.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TopbarComponent {
  element: any

  router = inject(Router)
  store = inject(Store)

  @Output() settingsButtonClicked = new EventEmitter()
  @Output() mobileMenuButtonClicked = new EventEmitter()

  constructor(
    @Inject(DOCUMENT) private document: any,
    public sessionService: SessionService
  ) {}

  ngOnInit(): void {
    this.element = document.documentElement
  }

  settingMenu() {
    this.settingsButtonClicked.emit()
  }

  toggleMobileMenu() {
    this.mobileMenuButtonClicked.emit()
  }

  changeTheme() {
    const color = document.documentElement.getAttribute('data-bs-theme')
    if (color == 'light') {
      this.store.dispatch(changetheme({ color: 'dark' }))
    } else {
      this.store.dispatch(changetheme({ color: 'light' }))
    }
    this.store.select(getLayoutColor).subscribe((color) => {
      document.documentElement.setAttribute('data-bs-theme', color)
    })
  }

  logout() {
    if (confirm('Are you sure you want to logout?')) {
      this.sessionService.logout();
    }
  }
}
